var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sc-message--system",class:{
      sent: _vm.message.author === 'me',
      received: _vm.message.author !== 'me'
    }},[_vm._v("\n  "+_vm._s(_vm.data.text)+"\n  "),(_vm.data.meta)?_c('p',{staticClass:"sc-message--meta"},[_vm._v("\n    "+_vm._s(_vm.data.meta))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d324fed0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/beautiful-chat/SystemMessage.vue
// module id = null
// module chunks = 